const countryArr = [
  {value: 1, label: "+46 Sweden"},
  {value: 2, label: "+41 Switzerland"},
  {value: 3, label: "+1 USA"},
  {value: 4, label: "+44 United Kingdom"},
  {value: 5, label: "+84 Vietnam"},
]
export { countryArr }